export default function Architektura(props) {
	return <span id="a11y-architektura">{props.children}</span>;
}
